import http from './http';

export interface AnuncioResponse {
  id: string;
  imageUrl?: string;
  targetRole: string;
}

export interface CreateAnuncioRequest {
  image: File;
}

export const anuncioRepository = {
  async create(data: CreateAnuncioRequest): Promise<AnuncioResponse> {
    if (!data.image) {
      throw new Error('No se proporcionó un archivo de imagen');
    }

    if (!(data.image instanceof File)) {
      throw new Error('El objeto proporcionado no es un archivo válido');
    }

    const formData = new FormData();
    formData.append('image', data.image, data.image.name);

    const imageFile = formData.get('image');
    if (!imageFile || !(imageFile instanceof File)) {
      throw new Error('Error al agregar la imagen al FormData');
    }

    try {
      return await http.post<AnuncioResponse, FormData>('/anuncio', formData, {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      });
    } catch (error) {
      console.error('Error detallado:', error);
      throw error;
    }
  },

  async getActive(): Promise<AnuncioResponse | null> {
    return await http.get<AnuncioResponse | null>('/anuncio/active');
  },

  async delete(id: string): Promise<void> {
    await http.delete(`/anuncio/${id}`);
  },
};

export default anuncioRepository;
